module.exports = __webpack_public_path__ + "img/size_2_5.f960a0ad.png";